<template>
  <form id="DcPostForm" method="POST" @submit.prevent="submitDcForm">

      <div v-show="loader" class="loader"></div>
    <input type="hidden" v-model="PurchaseOrderId" />
    <div class="form-group">
      <label for="date">Enter Recieving Date</label>
      <input id="date"
      type="date"
      v-model="date"
      class="form-control"
      required
      />
    </div>
    <div class="form-group">
      <label for="ReceiverName">Enter Receiver Name</label>
      <input
          id="ReceiverName"
        type="text"
        v-model="ReceiverName"
        class="form-control"
        placeholder="Enter Reciever Name"
        required
      />

    </div>

    <div class="modal-footer text-right">
      <button type="submit" class="btn btn-primary">Submit</button>
      <button  id="dismissDCModal" type="button" class="btn btn-default" data-dismiss="modal">
        Close
      </button>
    </div>
  </form>
</template>
<script>
export default {
  name: "delivery-challan-modal",
  props: {
    PurchaseOrderId: {
      type: Number,
    },
  },
  data() {
    return {
        loader: false,
        date: null,
        ReceiverName: null,
        URLDeliveryChallanPost: 'delivery-challan/store',
    };
  },
  methods: {
      submitDcForm() {
          this.loader = true
           var data = {
                'PurchaseOrderId': this.PurchaseOrderId,
                'Date' : this.date,
                'ReceivedBy': this.ReceiverName
            }
          axios.post(this.URLDeliveryChallanPost, data)
                .then(response => {
                    if(response.data.success != 1){} else {
                        Swal.fire({
                            title: 'Submitted Successfully',
                            icon: 'success',
                        })
                        this.$root.$refs.dcListObject.getDeliveryChallans()
                    }
                    location.reload()
                })
                .catch(error => {
                    this.errored = true
                })
                .finally(() => this.loader = false,
                     this.date = null,
                     this.ReceiverName = null
                     )
      },
  },
    created() {

    }
};
</script>

<style lang="scss" scoped>
</style>
